import { t } from "i18n/i18n";

export const AssessmentGradingNoSubmission = () => {
  return <div className="text-black-tint-40">{t("submission_assessment.no_submission")}</div>;
};
